import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { dangerNotification } from '../../../redux/slices/ui';

import { Forbidden, LightButton, Loader, PrimaryDropdownButton, TextInputPreview, TextInputPreviewHorizontal } from '../../../components';

import styles from '../Modals.module.css';

export const ViewConsultaModal = ({ configuracionConsulta, consulta, citaPendiente, cita, hide }) => {

    const { permisos } = useSelector(state => state.auth);

    const dispatch = useDispatch();

    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        try {
            setDownloading(true);
    
            const res = await fetch(
                process.env.REACT_APP_API_URL + `/consulta/receta/${consulta._id}`,
                {
                    method: "GET",
                    headers: {
                        'x-token': localStorage.getItem('token'),
                    },
                }
            );
    
            if (!res.ok) {
                const text = await res.text().catch(() => "");
                dispatch(dangerNotification(`Error ${res.status}: ${text || "No se pudo descargar"}`));
            }
    
            // Intenta obtener el filename del header
            const dispo = res.headers.get("Content-Disposition") || "";
            const match = dispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const fallbackName = `Receta.pdf`;
            let fileName = fallbackName;
    
            if (match && match[1]) {
                fileName = match[1].replace(/['"]/g, "");
                // Por si viene RFC5987: filename*=UTF-8''nombre.pdf
                const utf8Name = dispo.match(/filename\*\s*=\s*UTF-8''([^;\n]+)/i);
                if (utf8Name && utf8Name[1]) {
                fileName = decodeURIComponent(utf8Name[1]);
                }
            }
    
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
    
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName || fallbackName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            // console.error(err);
            dispatch(dangerNotification('No se pudo descargar el archivo.'));
        } finally {
            setDownloading(false);
        }
    };

    const handleCustomDownload = async () => {
        try {
            setDownloading(true);
    
            const res = await fetch(
                process.env.REACT_APP_API_URL + `/consulta/receta-custom/${consulta._id}`,
                {
                    method: "GET",
                    headers: {
                        'x-token': localStorage.getItem('token'),
                    },
                }
            );
    
            if (!res.ok) {
                const text = await res.text().catch(() => "");
                dispatch(dangerNotification(`Error ${res.status}: ${text || "No se pudo descargar"}`));
            }
    
            // Intenta obtener el filename del header
            const dispo = res.headers.get("Content-Disposition") || "";
            const match = dispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
            const fallbackName = `Receta.pdf`;
            let fileName = fallbackName;
    
            if (match && match[1]) {
                fileName = match[1].replace(/['"]/g, "");
                // Por si viene RFC5987: filename*=UTF-8''nombre.pdf
                const utf8Name = dispo.match(/filename\*\s*=\s*UTF-8''([^;\n]+)/i);
                if (utf8Name && utf8Name[1]) {
                fileName = decodeURIComponent(utf8Name[1]);
                }
            }
    
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
    
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName || fallbackName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            // console.error(err);
            dispatch(dangerNotification('No se pudo descargar el archivo.'));
        } finally {
            setDownloading(false);
        }
    };

    return (permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate || permisos.receta) ? (
        <>
            {(consulta === null)
                ? <Loader />
                : <>
                    <div>
                        <div className="row mb-3">
                            <div className="col">
                                <div className={styles.modalHeader}>Resumen</div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col">
                                <TextInputPreviewHorizontal
                                    label="Fecha"
                                    name="fecha"
                                    value={consulta.fechaFormato}
                                />
                            </div>
                            <div className="col"></div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <TextInputPreviewHorizontal
                                    label="Consulta"
                                    name="subsecuente"
                                    value={(consulta.subsecuente) ? 'Subsecuente' : 'Primera vez'}
                                />
                            </div>
                        </div>
                        {(configuracionConsulta.historiaClinica.motivoConsulta) &&
                        <div className="row">
                            <div className="col-md-12 col-lg-6">
                                <TextInputPreviewHorizontal
                                    label="Motivo"
                                    name="motivo"
                                    value={consulta.motivo}
                                />
                            </div>
                        </div>
                        }
                        {(configuracionConsulta.historiaClinica.peea) &&
                        <div className="row">
                            <div className="col">
                                <TextInputPreviewHorizontal
                                    label="PEEA"
                                    name="peea"
                                    value={consulta.peea}
                                />
                            </div>
                        </div>
                        }
                        <div className="accordion" id="accordionConsultaView">
                            {(typeof consulta.exploracionFisica !== 'undefined' && (configuracionConsulta.exploracionFisica.habitusExterior || configuracionConsulta.exploracionFisica.cabezaCuello || configuracionConsulta.exploracionFisica.torax || configuracionConsulta.exploracionFisica.abdomen || configuracionConsulta.exploracionFisica.piel || configuracionConsulta.exploracionFisica.extremidades || configuracionConsulta.exploracionFisica.genitales || configuracionConsulta.exploracionFisica.otro)) &&
                            <div key="accordionExploracionFisica" className="accordion-item">
                                <h2 className="accordion-header" id="headingExploracionFisica">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExploracionFisica" aria-expanded="false" aria-controls="collapseExploracionFisica">Exploración Física</button>
                                </h2>
                                <div id="collapseExploracionFisica" className="accordion-collapse collapse" aria-labelledby="headingExploracionFisica" data-bs-parent="#accordionExploracionFisica">
                                    <div className="accordion-body">
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.habitusExterior !== 'undefined' && configuracionConsulta.exploracionFisica.habitusExterior) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Habitus exterior"
                                                    name="habitusExterior"
                                                    value={consulta.exploracionFisica.habitusExterior}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.cabezaYCuello !== 'undefined' && configuracionConsulta.exploracionFisica.cabezaCuello) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Cabeza y cuello"
                                                    name="cabezaYCuello"
                                                    value={consulta.exploracionFisica.cabezaYCuello}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.torax !== 'undefined' && configuracionConsulta.exploracionFisica.torax) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Tórax"
                                                    name="torax"
                                                    value={consulta.exploracionFisica.torax}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.abdomen !== 'undefined' && configuracionConsulta.exploracionFisica.abdomen) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Abdomen"
                                                    name="abdomen"
                                                    value={consulta.exploracionFisica.abdomen}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.piel !== 'undefined' && configuracionConsulta.exploracionFisica.piel) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Piel"
                                                    name="piel"
                                                    value={consulta.exploracionFisica.piel}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.extremidades !== 'undefined' && configuracionConsulta.exploracionFisica.extremidades) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Extremidades"
                                                    name="extremidades"
                                                    value={consulta.exploracionFisica.extremidades}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.genitales !== 'undefined' && configuracionConsulta.exploracionFisica.genitales) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Genitales"
                                                    name="genitales"
                                                    value={consulta.exploracionFisica.genitales}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.exploracionFisica !== 'undefined' && typeof consulta.exploracionFisica.otro !== 'undefined' && configuracionConsulta.exploracionFisica.otro) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreviewHorizontal
                                                    label="Otro"
                                                    name="otro"
                                                    value={consulta.exploracionFisica.otro}
                                                />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            {(typeof consulta.signosVitales !== 'undefined' && (configuracionConsulta.signosVitales.frecuenciaCardiaca || configuracionConsulta.signosVitales.frecuenciaRespiratoria || configuracionConsulta.signosVitales.presionArterial || configuracionConsulta.signosVitales.temperatura || configuracionConsulta.signosVitales.sa02 || configuracionConsulta.signosVitales.peso || configuracionConsulta.signosVitales.talla || configuracionConsulta.signosVitales.imc || configuracionConsulta.signosVitales.fem)) &&
                            <div key="accordionSignosVitales" className="accordion-item">
                                <h2 className="accordion-header" id="headingSignosVitales">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSignosVitales" aria-expanded="false" aria-controls="collapseSignosVitales">Signos Vitales</button>
                                </h2>
                                <div id="collapseSignosVitales" className="accordion-collapse collapse" aria-labelledby="headingSignosVitales" data-bs-parent="#accordionSignosVitales">
                                    <div className="accordion-body">
                                        <div className="row">
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.fc !== 'undefined' && configuracionConsulta.signosVitales.frecuenciaCardiaca) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="FC"
                                                    name="fc"
                                                    value={consulta.signosVitales.fc + " lpm"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.fr !== 'undefined' && configuracionConsulta.signosVitales.frecuenciaRespiratoria) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="FR"
                                                    name="fr"
                                                    value={consulta.signosVitales.fr + " rpm"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.ta !== 'undefined' && configuracionConsulta.signosVitales.presionArterial) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="TA"
                                                    name="ta"
                                                    value={consulta.signosVitales.ta + " mmHg"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.t !== 'undefined' && configuracionConsulta.signosVitales.temperatura) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="T"
                                                    name="t"
                                                    value={consulta.signosVitales.t + " °C"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.saO2 !== 'undefined' && configuracionConsulta.signosVitales.sa02) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="SaO2"
                                                    name="saO2"
                                                    value={consulta.signosVitales.saO2 + " %"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.peso !== 'undefined' && configuracionConsulta.signosVitales.peso) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="Peso"
                                                    name="peso"
                                                    value={consulta.signosVitales.peso + " Kg"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.talla !== 'undefined' && configuracionConsulta.signosVitales.talla) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="Talla"
                                                    name="talla"
                                                    value={consulta.signosVitales.talla + " cm"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.imc !== 'undefined' && configuracionConsulta.signosVitales.imc) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="IMC"
                                                    name="imc"
                                                    value={consulta.signosVitales.imc + " kg/m2"}
                                                />
                                            </div>
                                            }
                                            {(typeof consulta.signosVitales !== 'undefined' && typeof consulta.signosVitales.fem !== 'undefined' && configuracionConsulta.signosVitales.fem) &&
                                            <div className="col-sm-12 col-md-6 col-lg-4">
                                                <TextInputPreviewHorizontal
                                                    label="FEM"
                                                    name="fem"
                                                    value={consulta.signosVitales.fem + " ml"}
                                                />
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {((typeof consulta.diagnosticos !== 'undefined' && consulta.diagnosticos.length > 0) || (typeof consulta.diagnosticosData !== 'undefined' && consulta.diagnosticosData !== '')) &&
                            <div key="accordionDiagnosticos" className="accordion-item">
                                <h2 className="accordion-header" id="headingDiagnosticos">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDiagnosticos" aria-expanded="false" aria-controls="collapseDiagnosticos">Diagnósticos</button>
                                </h2>
                                <div id="collapseDiagnosticos" className="accordion-collapse collapse" aria-labelledby="headingDiagnosticos" data-bs-parent="#accordionDiagnosticos">
                                    <div className="accordion-body">
                                        {(typeof consulta.diagnosticos !== 'undefined' && consulta.diagnosticos.length > 0) &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreview
                                                    label="Diagnósticos (CIE10)"
                                                    name="diagnosticosCIE10"
                                                    value={<>
                                                        { consulta.diagnosticos.map(diag => {
            
                                                            let diagnostico = '';
                                                            if(typeof diag.diagnostico !== 'undefined' && typeof diag.diagnostico.nombre !== 'undefined' && diag.diagnostico.nombre !== ''){
                                                                diagnostico = diag.diagnostico.nombre;
                                                            }
            
                                                            return <div key={diag._id} className="row">
                                                                <div className="col">
                                                                    <TextInputPreview
                                                                        label=""
                                                                        name="diagnostico"
                                                                        value={diagnostico}
                                                                        showLabel={false}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }) }
                                                    </>}
                                                />
                                            </div>
                                        </div>
                                        }
                                        {(typeof consulta.diagnosticosData !== 'undefined' && consulta.diagnosticosData !== '') &&
                                        <div className="row">
                                            <div className="col">
                                                <TextInputPreview
                                                    label="Diagnósticos"
                                                    name="diagnosticosData"
                                                    value={consulta.diagnosticosData}
                                                />
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                            {(typeof consulta.medicamentos !== 'undefined' && consulta.medicamentos.length > 0) &&
                            <div key="accordionMedicamentos" className="accordion-item">
                                <h2 className="accordion-header" id="headingMedicamentos">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMedicamentos" aria-expanded="false" aria-controls="collapseMedicamentos">Medicamentos</button>
                                </h2>
                                <div id="collapseMedicamentos" className="accordion-collapse collapse" aria-labelledby="headingMedicamentos" data-bs-parent="#accordionMedicamentos">
                                    <div className="accordion-body">
                                        <div className="row">
                                            <div className="col">
                                            { consulta.medicamentos.map(med => {
                                                return <div key={med._id}>
                                                    <TextInputPreview
                                                        label=""
                                                        name="medicamentos"
                                                        value={med.medicamento.nombre}
                                                        showLabel={false}
                                                    />
                                                </div>
                                            }) }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {(typeof consulta.estudios !== 'undefined' && consulta.estudios.length > 0) &&
                            <div key="accordionEstudios" className="accordion-item">
                                <h2 className="accordion-header" id="headingEstudios">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEstudios" aria-expanded="false" aria-controls="collapseEstudios">Estudios</button>
                                </h2>
                                <div id="collapseEstudios" className="accordion-collapse collapse" aria-labelledby="headingEstudios" data-bs-parent="#accordionEstudios">
                                    <div className="accordion-body">
                                        <div className="row">
                                            <div className="col">
                                            { consulta.estudios.map(est => {
                                                return <div key={est._id}>
                                                    <TextInputPreview
                                                        label=""
                                                        name="estudios"
                                                        value={est.nombre}
                                                        showLabel={false}
                                                    />
                                                </div>
                                            }) }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        {(citaPendiente) &&
                        <div className={styles.modalHelperText}>Próxima cita pendiente registrada: Completa los datos de la cita para agendarla</div>}
                        {(cita) &&
                        <div className={styles.modalHelperText}>Próxima cita registrada</div>}
                        <div className="row mt-4">
                            <div className='col-xs-12 col-sm-12 col-md'>
                                <LightButton
                                    block={true}
                                    icon="X"
                                    onClick={ hide }
                                    text="Cerrar"
                                    type="button"
                                />
                            </div>
                            {((typeof consulta.medicamentos !== 'undefined' && consulta.medicamentos.length > 0) || (typeof consulta.estudios !== 'undefined' && consulta.estudios.length > 0)) &&
                            <div className="col-xs-12 col-sm-12 col-md">
                                <PrimaryDropdownButton
                                    block={true}
                                    disabled={downloading}
                                    icon="Download"
                                    iconSize={0.8}
                                    iconMargin={5}
                                    text="Descargar receta"
                                    size={24}
                                    options={[
                                        {
                                            id: 'recetaInmunet',
                                            text: 'Receta Inmunet',
                                            onClick: handleDownload,
                                        },
                                        {
                                            id: 'recetaCustom',
                                            text: 'Receta personalizada',
                                            onClick: handleCustomDownload,
                                        }
                                    ]}
                                />
                            </div>
                            }
                        </div>
                    </div>
                </>
            }
        </>
    ) : <Forbidden />
}

ViewConsultaModal.propTypes = {
    configuracionConsulta: PropTypes.object.isRequired,
    consulta: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired
}